import React from "react";
import Design from "../pages/Design";

const Map = () => {
  return (
    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 p-2 max-sm:px-10  max-sm:pt-20 pt-24 px-24">
      <Design />
    </div>
  );
};

export default Map;
